import flatten from 'lodash/flatten';
import uniq from 'lodash/uniq';
export function extractSelectedTags(tagIds, tags) {
  if (!Array.isArray(tags) || !Array.isArray(tagIds)) return [];
  const selectedTags = tags?.filter(tag => {
    const foundTagId = tagIds?.find(tagId => tag?.id === tagId);
    return !!foundTagId;
  });
  return selectedTags;
}
export function extractSelectedTagIds(tagGroupFormValues) {
  const tagGroups = tagGroupFormValues?.tagGroups?.filter(tagGroup => !!tagGroup) || [];
  const tagIds = uniq(flatten(tagGroups));
  return tagIds;
}
export function buildTagGroupsTree(tagGroups, tagIds) {
  if (!Array.isArray(tagGroups)) return [];
  return tagGroups?.map(tagGroup => {
    const tags = tagGroup?.tags || [];
    const foundTags = tags.filter(({
      id
    }) => tagIds?.includes(id));
    return {
      ...tagGroup,
      tags: foundTags
    };
  });
}